// source: pbtypes/util/geofence/geofence.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector2f_pb = require('../../../pbtypes/gen/eigen_lcm/Vector2f_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector2f_pb);
var pbtypes_vehicle_skills_waypoints_pb = require('../../../pbtypes/vehicle/skills/waypoints_pb.js');
goog.object.extend(proto, pbtypes_vehicle_skills_waypoints_pb);
goog.exportSymbol('proto.geofence.Cylinder', null, global);
goog.exportSymbol('proto.geofence.Geofence', null, global);
goog.exportSymbol('proto.geofence.GeofenceShape', null, global);
goog.exportSymbol('proto.geofence.GeofenceShape.ShapeCase', null, global);
goog.exportSymbol('proto.geofence.GeofenceShape.Source', null, global);
goog.exportSymbol('proto.geofence.HeightLimits', null, global);
goog.exportSymbol('proto.geofence.MaxSupportedGeofencePolygonVertices', null, global);
goog.exportSymbol('proto.geofence.MaxSupportedGeofencePolygonVertices.Enum', null, global);
goog.exportSymbol('proto.geofence.Metadata', null, global);
goog.exportSymbol('proto.geofence.ParsingError', null, global);
goog.exportSymbol('proto.geofence.ParsingError.Error', null, global);
goog.exportSymbol('proto.geofence.ParsingResult', null, global);
goog.exportSymbol('proto.geofence.ParsingResult.Status', null, global);
goog.exportSymbol('proto.geofence.ParsingWarning', null, global);
goog.exportSymbol('proto.geofence.ParsingWarning.Warning', null, global);
goog.exportSymbol('proto.geofence.Polygon', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.geofence.Geofence = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.geofence.Geofence.repeatedFields_, null);
};
goog.inherits(proto.geofence.Geofence, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.geofence.Geofence.displayName = 'proto.geofence.Geofence';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.geofence.GeofenceShape = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.geofence.GeofenceShape.oneofGroups_);
};
goog.inherits(proto.geofence.GeofenceShape, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.geofence.GeofenceShape.displayName = 'proto.geofence.GeofenceShape';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.geofence.Metadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.geofence.Metadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.geofence.Metadata.displayName = 'proto.geofence.Metadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.geofence.HeightLimits = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.geofence.HeightLimits, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.geofence.HeightLimits.displayName = 'proto.geofence.HeightLimits';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.geofence.Cylinder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.geofence.Cylinder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.geofence.Cylinder.displayName = 'proto.geofence.Cylinder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.geofence.Polygon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.geofence.Polygon.repeatedFields_, null);
};
goog.inherits(proto.geofence.Polygon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.geofence.Polygon.displayName = 'proto.geofence.Polygon';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.geofence.ParsingError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.geofence.ParsingError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.geofence.ParsingError.displayName = 'proto.geofence.ParsingError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.geofence.ParsingWarning = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.geofence.ParsingWarning, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.geofence.ParsingWarning.displayName = 'proto.geofence.ParsingWarning';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.geofence.ParsingResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.geofence.ParsingResult.repeatedFields_, null);
};
goog.inherits(proto.geofence.ParsingResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.geofence.ParsingResult.displayName = 'proto.geofence.ParsingResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.geofence.MaxSupportedGeofencePolygonVertices = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.geofence.MaxSupportedGeofencePolygonVertices, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.geofence.MaxSupportedGeofencePolygonVertices.displayName = 'proto.geofence.MaxSupportedGeofencePolygonVertices';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.geofence.Geofence.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.geofence.Geofence.prototype.toObject = function(opt_includeInstance) {
  return proto.geofence.Geofence.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.geofence.Geofence} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.Geofence.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
shapesList: jspb.Message.toObjectList(msg.getShapesList(),
    proto.geofence.GeofenceShape.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.geofence.Geofence}
 */
proto.geofence.Geofence.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.geofence.Geofence;
  return proto.geofence.Geofence.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.geofence.Geofence} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.geofence.Geofence}
 */
proto.geofence.Geofence.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = new proto.geofence.GeofenceShape;
      reader.readMessage(value,proto.geofence.GeofenceShape.deserializeBinaryFromReader);
      msg.addShapes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.geofence.Geofence.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.geofence.Geofence.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.geofence.Geofence} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.Geofence.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getShapesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.geofence.GeofenceShape.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.geofence.Geofence.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.geofence.Geofence} returns this
 */
proto.geofence.Geofence.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated GeofenceShape shapes = 2;
 * @return {!Array<!proto.geofence.GeofenceShape>}
 */
proto.geofence.Geofence.prototype.getShapesList = function() {
  return /** @type{!Array<!proto.geofence.GeofenceShape>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.geofence.GeofenceShape, 2));
};


/**
 * @param {!Array<!proto.geofence.GeofenceShape>} value
 * @return {!proto.geofence.Geofence} returns this
*/
proto.geofence.Geofence.prototype.setShapesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.geofence.GeofenceShape=} opt_value
 * @param {number=} opt_index
 * @return {!proto.geofence.GeofenceShape}
 */
proto.geofence.Geofence.prototype.addShapes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.geofence.GeofenceShape, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.geofence.Geofence} returns this
 */
proto.geofence.Geofence.prototype.clearShapesList = function() {
  return this.setShapesList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.geofence.GeofenceShape.oneofGroups_ = [[100,101]];

/**
 * @enum {number}
 */
proto.geofence.GeofenceShape.ShapeCase = {
  SHAPE_NOT_SET: 0,
  CYLINDER: 100,
  POLY_2D: 101
};

/**
 * @return {proto.geofence.GeofenceShape.ShapeCase}
 */
proto.geofence.GeofenceShape.prototype.getShapeCase = function() {
  return /** @type {proto.geofence.GeofenceShape.ShapeCase} */(jspb.Message.computeOneofCase(this, proto.geofence.GeofenceShape.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.geofence.GeofenceShape.prototype.toObject = function(opt_includeInstance) {
  return proto.geofence.GeofenceShape.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.geofence.GeofenceShape} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.GeofenceShape.toObject = function(includeInstance, msg) {
  var f, obj = {
frame: jspb.Message.getFieldWithDefault(msg, 1, 0),
keepOut: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
source: jspb.Message.getFieldWithDefault(msg, 3, 0),
metadata: (f = msg.getMetadata()) && proto.geofence.Metadata.toObject(includeInstance, f),
cylinder: (f = msg.getCylinder()) && proto.geofence.Cylinder.toObject(includeInstance, f),
poly2d: (f = msg.getPoly2d()) && proto.geofence.Polygon.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.geofence.GeofenceShape}
 */
proto.geofence.GeofenceShape.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.geofence.GeofenceShape;
  return proto.geofence.GeofenceShape.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.geofence.GeofenceShape} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.geofence.GeofenceShape}
 */
proto.geofence.GeofenceShape.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.skills.FrameType.Enum} */ (reader.readEnum());
      msg.setFrame(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setKeepOut(value);
      break;
    case 3:
      var value = /** @type {!proto.geofence.GeofenceShape.Source} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 4:
      var value = new proto.geofence.Metadata;
      reader.readMessage(value,proto.geofence.Metadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 100:
      var value = new proto.geofence.Cylinder;
      reader.readMessage(value,proto.geofence.Cylinder.deserializeBinaryFromReader);
      msg.setCylinder(value);
      break;
    case 101:
      var value = new proto.geofence.Polygon;
      reader.readMessage(value,proto.geofence.Polygon.deserializeBinaryFromReader);
      msg.setPoly2d(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.geofence.GeofenceShape.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.geofence.GeofenceShape.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.geofence.GeofenceShape} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.GeofenceShape.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrame();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getKeepOut();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.geofence.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getCylinder();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.geofence.Cylinder.serializeBinaryToWriter
    );
  }
  f = message.getPoly2d();
  if (f != null) {
    writer.writeMessage(
      101,
      f,
      proto.geofence.Polygon.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.geofence.GeofenceShape.Source = {
  UNKNOWN: 0,
  MAVLINK_PARAM: 1,
  MAVLINK_MISSION: 2
};

/**
 * optional skills.FrameType.Enum frame = 1;
 * @return {!proto.skills.FrameType.Enum}
 */
proto.geofence.GeofenceShape.prototype.getFrame = function() {
  return /** @type {!proto.skills.FrameType.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.skills.FrameType.Enum} value
 * @return {!proto.geofence.GeofenceShape} returns this
 */
proto.geofence.GeofenceShape.prototype.setFrame = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool keep_out = 2;
 * @return {boolean}
 */
proto.geofence.GeofenceShape.prototype.getKeepOut = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.geofence.GeofenceShape} returns this
 */
proto.geofence.GeofenceShape.prototype.setKeepOut = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional Source source = 3;
 * @return {!proto.geofence.GeofenceShape.Source}
 */
proto.geofence.GeofenceShape.prototype.getSource = function() {
  return /** @type {!proto.geofence.GeofenceShape.Source} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.geofence.GeofenceShape.Source} value
 * @return {!proto.geofence.GeofenceShape} returns this
 */
proto.geofence.GeofenceShape.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Metadata metadata = 4;
 * @return {?proto.geofence.Metadata}
 */
proto.geofence.GeofenceShape.prototype.getMetadata = function() {
  return /** @type{?proto.geofence.Metadata} */ (
    jspb.Message.getWrapperField(this, proto.geofence.Metadata, 4));
};


/**
 * @param {?proto.geofence.Metadata|undefined} value
 * @return {!proto.geofence.GeofenceShape} returns this
*/
proto.geofence.GeofenceShape.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.geofence.GeofenceShape} returns this
 */
proto.geofence.GeofenceShape.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.geofence.GeofenceShape.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Cylinder cylinder = 100;
 * @return {?proto.geofence.Cylinder}
 */
proto.geofence.GeofenceShape.prototype.getCylinder = function() {
  return /** @type{?proto.geofence.Cylinder} */ (
    jspb.Message.getWrapperField(this, proto.geofence.Cylinder, 100));
};


/**
 * @param {?proto.geofence.Cylinder|undefined} value
 * @return {!proto.geofence.GeofenceShape} returns this
*/
proto.geofence.GeofenceShape.prototype.setCylinder = function(value) {
  return jspb.Message.setOneofWrapperField(this, 100, proto.geofence.GeofenceShape.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.geofence.GeofenceShape} returns this
 */
proto.geofence.GeofenceShape.prototype.clearCylinder = function() {
  return this.setCylinder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.geofence.GeofenceShape.prototype.hasCylinder = function() {
  return jspb.Message.getField(this, 100) != null;
};


/**
 * optional Polygon poly_2d = 101;
 * @return {?proto.geofence.Polygon}
 */
proto.geofence.GeofenceShape.prototype.getPoly2d = function() {
  return /** @type{?proto.geofence.Polygon} */ (
    jspb.Message.getWrapperField(this, proto.geofence.Polygon, 101));
};


/**
 * @param {?proto.geofence.Polygon|undefined} value
 * @return {!proto.geofence.GeofenceShape} returns this
*/
proto.geofence.GeofenceShape.prototype.setPoly2d = function(value) {
  return jspb.Message.setOneofWrapperField(this, 101, proto.geofence.GeofenceShape.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.geofence.GeofenceShape} returns this
 */
proto.geofence.GeofenceShape.prototype.clearPoly2d = function() {
  return this.setPoly2d(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.geofence.GeofenceShape.prototype.hasPoly2d = function() {
  return jspb.Message.getField(this, 101) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.geofence.Metadata.prototype.toObject = function(opt_includeInstance) {
  return proto.geofence.Metadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.geofence.Metadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.Metadata.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
country: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.geofence.Metadata}
 */
proto.geofence.Metadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.geofence.Metadata;
  return proto.geofence.Metadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.geofence.Metadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.geofence.Metadata}
 */
proto.geofence.Metadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCountry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.geofence.Metadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.geofence.Metadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.geofence.Metadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.Metadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.geofence.Metadata.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.geofence.Metadata} returns this
 */
proto.geofence.Metadata.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string country = 2;
 * @return {string}
 */
proto.geofence.Metadata.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.geofence.Metadata} returns this
 */
proto.geofence.Metadata.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.geofence.HeightLimits.prototype.toObject = function(opt_includeInstance) {
  return proto.geofence.HeightLimits.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.geofence.HeightLimits} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.HeightLimits.toObject = function(includeInstance, msg) {
  var f, obj = {
floor: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
floorEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
ceiling: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
ceilingEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
frame: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.geofence.HeightLimits}
 */
proto.geofence.HeightLimits.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.geofence.HeightLimits;
  return proto.geofence.HeightLimits.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.geofence.HeightLimits} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.geofence.HeightLimits}
 */
proto.geofence.HeightLimits.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFloor(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFloorEnabled(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCeiling(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCeilingEnabled(value);
      break;
    case 5:
      var value = /** @type {!proto.skills.FrameType.Enum} */ (reader.readEnum());
      msg.setFrame(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.geofence.HeightLimits.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.geofence.HeightLimits.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.geofence.HeightLimits} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.HeightLimits.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFloor();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getFloorEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getCeiling();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getCeilingEnabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getFrame();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional float floor = 1;
 * @return {number}
 */
proto.geofence.HeightLimits.prototype.getFloor = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.geofence.HeightLimits} returns this
 */
proto.geofence.HeightLimits.prototype.setFloor = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional bool floor_enabled = 2;
 * @return {boolean}
 */
proto.geofence.HeightLimits.prototype.getFloorEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.geofence.HeightLimits} returns this
 */
proto.geofence.HeightLimits.prototype.setFloorEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional float ceiling = 3;
 * @return {number}
 */
proto.geofence.HeightLimits.prototype.getCeiling = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.geofence.HeightLimits} returns this
 */
proto.geofence.HeightLimits.prototype.setCeiling = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional bool ceiling_enabled = 4;
 * @return {boolean}
 */
proto.geofence.HeightLimits.prototype.getCeilingEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.geofence.HeightLimits} returns this
 */
proto.geofence.HeightLimits.prototype.setCeilingEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional skills.FrameType.Enum frame = 5;
 * @return {!proto.skills.FrameType.Enum}
 */
proto.geofence.HeightLimits.prototype.getFrame = function() {
  return /** @type {!proto.skills.FrameType.Enum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.skills.FrameType.Enum} value
 * @return {!proto.geofence.HeightLimits} returns this
 */
proto.geofence.HeightLimits.prototype.setFrame = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.geofence.Cylinder.prototype.toObject = function(opt_includeInstance) {
  return proto.geofence.Cylinder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.geofence.Cylinder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.Cylinder.toObject = function(includeInstance, msg) {
  var f, obj = {
radius: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
center: (f = msg.getCenter()) && pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb.toObject(includeInstance, f),
heightLimits: (f = msg.getHeightLimits()) && proto.geofence.HeightLimits.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.geofence.Cylinder}
 */
proto.geofence.Cylinder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.geofence.Cylinder;
  return proto.geofence.Cylinder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.geofence.Cylinder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.geofence.Cylinder}
 */
proto.geofence.Cylinder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRadius(value);
      break;
    case 2:
      var value = new pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb.deserializeBinaryFromReader);
      msg.setCenter(value);
      break;
    case 3:
      var value = new proto.geofence.HeightLimits;
      reader.readMessage(value,proto.geofence.HeightLimits.deserializeBinaryFromReader);
      msg.setHeightLimits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.geofence.Cylinder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.geofence.Cylinder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.geofence.Cylinder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.Cylinder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRadius();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getCenter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb.serializeBinaryToWriter
    );
  }
  f = message.getHeightLimits();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.geofence.HeightLimits.serializeBinaryToWriter
    );
  }
};


/**
 * optional float radius = 1;
 * @return {number}
 */
proto.geofence.Cylinder.prototype.getRadius = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.geofence.Cylinder} returns this
 */
proto.geofence.Cylinder.prototype.setRadius = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional eigen_lcm.Vector2fPb center = 2;
 * @return {?proto.eigen_lcm.Vector2fPb}
 */
proto.geofence.Cylinder.prototype.getCenter = function() {
  return /** @type{?proto.eigen_lcm.Vector2fPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb, 2));
};


/**
 * @param {?proto.eigen_lcm.Vector2fPb|undefined} value
 * @return {!proto.geofence.Cylinder} returns this
*/
proto.geofence.Cylinder.prototype.setCenter = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.geofence.Cylinder} returns this
 */
proto.geofence.Cylinder.prototype.clearCenter = function() {
  return this.setCenter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.geofence.Cylinder.prototype.hasCenter = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional HeightLimits height_limits = 3;
 * @return {?proto.geofence.HeightLimits}
 */
proto.geofence.Cylinder.prototype.getHeightLimits = function() {
  return /** @type{?proto.geofence.HeightLimits} */ (
    jspb.Message.getWrapperField(this, proto.geofence.HeightLimits, 3));
};


/**
 * @param {?proto.geofence.HeightLimits|undefined} value
 * @return {!proto.geofence.Cylinder} returns this
*/
proto.geofence.Cylinder.prototype.setHeightLimits = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.geofence.Cylinder} returns this
 */
proto.geofence.Cylinder.prototype.clearHeightLimits = function() {
  return this.setHeightLimits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.geofence.Cylinder.prototype.hasHeightLimits = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.geofence.Polygon.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.geofence.Polygon.prototype.toObject = function(opt_includeInstance) {
  return proto.geofence.Polygon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.geofence.Polygon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.Polygon.toObject = function(includeInstance, msg) {
  var f, obj = {
verticesList: jspb.Message.toObjectList(msg.getVerticesList(),
    pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb.toObject, includeInstance),
heightLimits: (f = msg.getHeightLimits()) && proto.geofence.HeightLimits.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.geofence.Polygon}
 */
proto.geofence.Polygon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.geofence.Polygon;
  return proto.geofence.Polygon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.geofence.Polygon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.geofence.Polygon}
 */
proto.geofence.Polygon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb.deserializeBinaryFromReader);
      msg.addVertices(value);
      break;
    case 3:
      var value = new proto.geofence.HeightLimits;
      reader.readMessage(value,proto.geofence.HeightLimits.deserializeBinaryFromReader);
      msg.setHeightLimits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.geofence.Polygon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.geofence.Polygon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.geofence.Polygon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.Polygon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerticesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb.serializeBinaryToWriter
    );
  }
  f = message.getHeightLimits();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.geofence.HeightLimits.serializeBinaryToWriter
    );
  }
};


/**
 * repeated eigen_lcm.Vector2fPb vertices = 1;
 * @return {!Array<!proto.eigen_lcm.Vector2fPb>}
 */
proto.geofence.Polygon.prototype.getVerticesList = function() {
  return /** @type{!Array<!proto.eigen_lcm.Vector2fPb>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb, 1));
};


/**
 * @param {!Array<!proto.eigen_lcm.Vector2fPb>} value
 * @return {!proto.geofence.Polygon} returns this
*/
proto.geofence.Polygon.prototype.setVerticesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.eigen_lcm.Vector2fPb=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eigen_lcm.Vector2fPb}
 */
proto.geofence.Polygon.prototype.addVertices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.eigen_lcm.Vector2fPb, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.geofence.Polygon} returns this
 */
proto.geofence.Polygon.prototype.clearVerticesList = function() {
  return this.setVerticesList([]);
};


/**
 * optional HeightLimits height_limits = 3;
 * @return {?proto.geofence.HeightLimits}
 */
proto.geofence.Polygon.prototype.getHeightLimits = function() {
  return /** @type{?proto.geofence.HeightLimits} */ (
    jspb.Message.getWrapperField(this, proto.geofence.HeightLimits, 3));
};


/**
 * @param {?proto.geofence.HeightLimits|undefined} value
 * @return {!proto.geofence.Polygon} returns this
*/
proto.geofence.Polygon.prototype.setHeightLimits = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.geofence.Polygon} returns this
 */
proto.geofence.Polygon.prototype.clearHeightLimits = function() {
  return this.setHeightLimits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.geofence.Polygon.prototype.hasHeightLimits = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.geofence.ParsingError.prototype.toObject = function(opt_includeInstance) {
  return proto.geofence.ParsingError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.geofence.ParsingError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.ParsingError.toObject = function(includeInstance, msg) {
  var f, obj = {
error: jspb.Message.getFieldWithDefault(msg, 1, 0),
detail: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.geofence.ParsingError}
 */
proto.geofence.ParsingError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.geofence.ParsingError;
  return proto.geofence.ParsingError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.geofence.ParsingError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.geofence.ParsingError}
 */
proto.geofence.ParsingError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.geofence.ParsingError.Error} */ (reader.readEnum());
      msg.setError(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.geofence.ParsingError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.geofence.ParsingError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.geofence.ParsingError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.ParsingError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDetail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.geofence.ParsingError.Error = {
  UNKNOWN: 0,
  MISSING_REQUIRED_FILED: 1,
  FAILED_TO_PARSE_REQUIRED_VALUE: 2,
  UNRECOGNIZED_ENUM_VALUE: 3
};

/**
 * optional Error error = 1;
 * @return {!proto.geofence.ParsingError.Error}
 */
proto.geofence.ParsingError.prototype.getError = function() {
  return /** @type {!proto.geofence.ParsingError.Error} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.geofence.ParsingError.Error} value
 * @return {!proto.geofence.ParsingError} returns this
 */
proto.geofence.ParsingError.prototype.setError = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string detail = 2;
 * @return {string}
 */
proto.geofence.ParsingError.prototype.getDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.geofence.ParsingError} returns this
 */
proto.geofence.ParsingError.prototype.setDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.geofence.ParsingWarning.prototype.toObject = function(opt_includeInstance) {
  return proto.geofence.ParsingWarning.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.geofence.ParsingWarning} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.ParsingWarning.toObject = function(includeInstance, msg) {
  var f, obj = {
warning: jspb.Message.getFieldWithDefault(msg, 1, 0),
detail: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.geofence.ParsingWarning}
 */
proto.geofence.ParsingWarning.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.geofence.ParsingWarning;
  return proto.geofence.ParsingWarning.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.geofence.ParsingWarning} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.geofence.ParsingWarning}
 */
proto.geofence.ParsingWarning.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.geofence.ParsingWarning.Warning} */ (reader.readEnum());
      msg.setWarning(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.geofence.ParsingWarning.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.geofence.ParsingWarning.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.geofence.ParsingWarning} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.ParsingWarning.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWarning();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDetail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.geofence.ParsingWarning.Warning = {
  UNKNOWN: 0,
  FAILED_TO_PARSE_OPTIONAL_VALUE: 2
};

/**
 * optional Warning warning = 1;
 * @return {!proto.geofence.ParsingWarning.Warning}
 */
proto.geofence.ParsingWarning.prototype.getWarning = function() {
  return /** @type {!proto.geofence.ParsingWarning.Warning} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.geofence.ParsingWarning.Warning} value
 * @return {!proto.geofence.ParsingWarning} returns this
 */
proto.geofence.ParsingWarning.prototype.setWarning = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string detail = 2;
 * @return {string}
 */
proto.geofence.ParsingWarning.prototype.getDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.geofence.ParsingWarning} returns this
 */
proto.geofence.ParsingWarning.prototype.setDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.geofence.ParsingResult.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.geofence.ParsingResult.prototype.toObject = function(opt_includeInstance) {
  return proto.geofence.ParsingResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.geofence.ParsingResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.ParsingResult.toObject = function(includeInstance, msg) {
  var f, obj = {
status: jspb.Message.getFieldWithDefault(msg, 1, 0),
errorsList: jspb.Message.toObjectList(msg.getErrorsList(),
    proto.geofence.ParsingError.toObject, includeInstance),
warningsList: jspb.Message.toObjectList(msg.getWarningsList(),
    proto.geofence.ParsingWarning.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.geofence.ParsingResult}
 */
proto.geofence.ParsingResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.geofence.ParsingResult;
  return proto.geofence.ParsingResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.geofence.ParsingResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.geofence.ParsingResult}
 */
proto.geofence.ParsingResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.geofence.ParsingResult.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = new proto.geofence.ParsingError;
      reader.readMessage(value,proto.geofence.ParsingError.deserializeBinaryFromReader);
      msg.addErrors(value);
      break;
    case 3:
      var value = new proto.geofence.ParsingWarning;
      reader.readMessage(value,proto.geofence.ParsingWarning.deserializeBinaryFromReader);
      msg.addWarnings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.geofence.ParsingResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.geofence.ParsingResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.geofence.ParsingResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.ParsingResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getErrorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.geofence.ParsingError.serializeBinaryToWriter
    );
  }
  f = message.getWarningsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.geofence.ParsingWarning.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.geofence.ParsingResult.Status = {
  UNKNOWN: 0,
  SUCCESS: 1,
  FAILED: 2,
  FAILED_TO_FIND: 3
};

/**
 * optional Status status = 1;
 * @return {!proto.geofence.ParsingResult.Status}
 */
proto.geofence.ParsingResult.prototype.getStatus = function() {
  return /** @type {!proto.geofence.ParsingResult.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.geofence.ParsingResult.Status} value
 * @return {!proto.geofence.ParsingResult} returns this
 */
proto.geofence.ParsingResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated ParsingError errors = 2;
 * @return {!Array<!proto.geofence.ParsingError>}
 */
proto.geofence.ParsingResult.prototype.getErrorsList = function() {
  return /** @type{!Array<!proto.geofence.ParsingError>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.geofence.ParsingError, 2));
};


/**
 * @param {!Array<!proto.geofence.ParsingError>} value
 * @return {!proto.geofence.ParsingResult} returns this
*/
proto.geofence.ParsingResult.prototype.setErrorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.geofence.ParsingError=} opt_value
 * @param {number=} opt_index
 * @return {!proto.geofence.ParsingError}
 */
proto.geofence.ParsingResult.prototype.addErrors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.geofence.ParsingError, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.geofence.ParsingResult} returns this
 */
proto.geofence.ParsingResult.prototype.clearErrorsList = function() {
  return this.setErrorsList([]);
};


/**
 * repeated ParsingWarning warnings = 3;
 * @return {!Array<!proto.geofence.ParsingWarning>}
 */
proto.geofence.ParsingResult.prototype.getWarningsList = function() {
  return /** @type{!Array<!proto.geofence.ParsingWarning>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.geofence.ParsingWarning, 3));
};


/**
 * @param {!Array<!proto.geofence.ParsingWarning>} value
 * @return {!proto.geofence.ParsingResult} returns this
*/
proto.geofence.ParsingResult.prototype.setWarningsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.geofence.ParsingWarning=} opt_value
 * @param {number=} opt_index
 * @return {!proto.geofence.ParsingWarning}
 */
proto.geofence.ParsingResult.prototype.addWarnings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.geofence.ParsingWarning, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.geofence.ParsingResult} returns this
 */
proto.geofence.ParsingResult.prototype.clearWarningsList = function() {
  return this.setWarningsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.geofence.MaxSupportedGeofencePolygonVertices.prototype.toObject = function(opt_includeInstance) {
  return proto.geofence.MaxSupportedGeofencePolygonVertices.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.geofence.MaxSupportedGeofencePolygonVertices} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.MaxSupportedGeofencePolygonVertices.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.geofence.MaxSupportedGeofencePolygonVertices}
 */
proto.geofence.MaxSupportedGeofencePolygonVertices.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.geofence.MaxSupportedGeofencePolygonVertices;
  return proto.geofence.MaxSupportedGeofencePolygonVertices.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.geofence.MaxSupportedGeofencePolygonVertices} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.geofence.MaxSupportedGeofencePolygonVertices}
 */
proto.geofence.MaxSupportedGeofencePolygonVertices.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.geofence.MaxSupportedGeofencePolygonVertices.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.geofence.MaxSupportedGeofencePolygonVertices.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.geofence.MaxSupportedGeofencePolygonVertices} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.geofence.MaxSupportedGeofencePolygonVertices.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.geofence.MaxSupportedGeofencePolygonVertices.Enum = {
  UNKNOWN: 0,
  SUPPORTS_1000: 1
};

goog.object.extend(exports, proto.geofence);
